import { render, staticRenderFns } from "./huoyun.vue?vue&type=template&id=77e252d0&scoped=true&"
import script from "./huoyun.vue?vue&type=script&lang=js&"
export * from "./huoyun.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=77e252d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e252d0",
  null
  
)

export default component.exports